import { styled } from '@mui/material';
import useTranslation from 'next-translate/useTranslation';
import theme from 'src/themes';

type SkipContentLinkProps = {
  href: string;
  label: string;
};

const StyledALink = styled('a')(() => ({
  width: '1px',
  height: '1px',
  overflow: 'hidden',
  display: 'block',

  '&:focus': {
    padding: theme.spacing(1),
    width: 'auto',
    height: 'auto',
    fontSize: 16,
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
    textDecoration: 'underline',
    overflow: 'visible',
  },
}));

const SkipContentLink = (props: SkipContentLinkProps) => {
  const { href, label } = props;

  const { t } = useTranslation();
  return <StyledALink href={href}>{t(label)}</StyledALink>;
};

export default SkipContentLink;
